export type ServiceWorkerRegistrationResult =
  | {supported: true; registration: ServiceWorkerRegistration}
  | {supported: false; reason: "insecure-context" | "unsupported" | "registration-failed"};

export async function registerServiceWorker(): Promise<ServiceWorkerRegistrationResult> {
  if (!window.isSecureContext) {
    return {supported: false, reason: "insecure-context"};
  }

  if (!("serviceWorker" in navigator) || !("PushManager" in window) || !("Notification" in window)) {
    return {supported: false, reason: "unsupported"};
  }

  try {
    const registration = await navigator.serviceWorker.register("/sw.js", {scope: "/"});
    return {supported: true, registration};
  } catch (error) {
    console.warn("Service worker registration failed", error);
    return {supported: false, reason: "registration-failed"};
  }
}

export function registerServiceWorkerAfterPageLoad(): void {
  const register = () => void registerServiceWorker();

  if (document.readyState === "complete") {
    register();
    return;
  }

  window.addEventListener("load", register, {once: true});
}
